export default __webpack_public_path__ + "static/media/Leviathan.c894c7c2.jpg";